<template>
    <div>
        <div class="flex-between">
            <el-button class="primary" type="primary" @click="dialogVisible = true">新建</el-button>
            <div class="input_box">
                <input
                    type="text"
                    v-model="queryData.query"
                    @keyup.enter="listByPageFun"
                    placeholder="请输入关键字检索"
                />
                 <span style="cursor: pointer" @click="listByPageFun"><i class="el-icon-search"></i></span>
            </div>
        </div>
        <div>
            <el-table
                :header-cell-style="{
					background: 'rgba(229,244,255,1)',
					color: '#0077CC',
					fontWeight: 'bold'
				}"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="username" label="用户名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="fullname" label="真实姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="telephone" label="联系电话" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDt" label="创建时间" header-align="center" align="center">
                    <template slot-scope="scope">{{scope.row.createDt | timestampToTime}}</template>
                </el-table-column>
                <el-table-column prop="state" label="状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <span
                            :style="{color:(scope.row.userState==1?'#666666':'#FF3333')}"
                        >{{scope.row.userState==1?'已启用':'已禁用'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button @click="deleteUserFun(scope.row.id)" type="text" size="small">删除</el-button>
                        <el-button type="text" size="small" @click="listByIdsFun(scope.row)">修改</el-button>
                        <el-button type="text" v-if="scope.row.userState==1" size="small" @click="disableUserFun(scope.row.id)">禁用</el-button>
                        <el-button type="text" v-else size="small" @click="enableUserFun(scope.row.id)">启用</el-button>
                        <el-button
                            @click="resetPasswordFun(scope.row.id)"
                            type="text"
                            size="small"
                        >重置密码</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="flex-end">
            当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.currentPage"
                :page-size="queryData.pageSize"
                layout="prev, pager, next, jumper"
                :total="queryData.total"
                style="padding: 45px; text-align:right;"
            ></el-pagination>
        </div>
        <el-dialog
            title="编辑用户"
            :visible.sync="dialogVisible"
            width="60%"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <!-- <span>这是一段信息</span> -->

            <div>
                <el-form
                    :model="ruleForm"
                    hide-required-asterisk
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    label-position="right"
                    class="system_box"
                >
                    <el-form-item label="用户名" prop="username" class="block_box">
                        <el-input v-model="ruleForm.username"></el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名" prop="fullname1">
                        <el-input v-model="ruleForm.fullname1" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password1">
                        <el-input :type="password" v-model="ruleForm.password1" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="passwordSure" class="block_box">
                        <el-input :type="password" v-model="ruleForm.passwordSure" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="telephone">
                        <el-input v-model="ruleForm.telephone"></el-input>
                    </el-form-item>
                    <el-form-item label="立即启用">
                        <el-checkbox v-model="ruleForm.salt"> 是</el-checkbox>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="el-button" @click="handleClose">返 回</button>
                <button class="el-button1" @click="submitForm('ruleForm')">确 定</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    listByPage, //列表查询
    insertUser, //新增用户
    disableUser, //禁用用户
    enableUser,//启用用户
    deleteUser, //删除用户
    listByIds, //根据ID查询用户
    updateUser, //修改用户信息
    resetPassword //重置密码

    // editPassword
} from "../../../api/system.js";
export default {
    name: "breadcrumbList",
    filters: {
        timestampToTime(timestamp) {
            
            let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            if(!timestamp){
                return '';
            }
            let Y = date.getFullYear() + "-";
            let M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            let D = date.getDate() + " ";
            let h = date.getHours() + ":";
            let m = date.getMinutes() + ":";
            let s = date.getSeconds();
            return Y + M + D + h + m + s;
        }
    },
    data() {
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.password1) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            search: "",
            tableData: [
               
            ],
            dialogVisible: false,
            content: "",
            editorOption: {},
            password:'password',
            ruleForm: {
                username: "",
                fullname1: "",
                telephone: "",
                password1: "",
                passwordSure: "",
                salt: false
            },
            rules: {
                username: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }
                ],
                fullname1: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "blur"
                    }
                ],
                telephone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur"
                    }
                ],
                password1: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    }
                ],
                passwordSure: [{ validator: validatePass2, trigger: "blur" }]
            },
            options: [
                {
                    value: "选项1",
                    label: "黄金糕"
                },
                {
                    value: "选项2",
                    label: "双皮奶"
                },
                {
                    value: "选项3",
                    label: "蚵仔煎"
                },
                {
                    value: "选项4",
                    label: "龙须面"
                },
                {
                    value: "选项5",
                    label: "北京烤鸭"
                }
            ],
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
                total: 0,
                search: "", //模糊搜索
                pages: "" //共多少页
            }
        };
    },
    methods: {
        handleClose(done) {
            this.$refs["ruleForm"].resetFields();
            this.ruleForm = {
                username: "",
                fullname1: "",
                telephone: "",
                password1: "",
                passwordSure: "",
                salt: false
            };
            // this.ruleForm.salt = false;
            this.dialogVisible = false;
        },
        handleSizeChange(val) {
            this.queryData.pageSize = val;
            this.listByPageFun();
            //console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            //console.log(val);
            this.queryData.currentPage = val;
            //console.log(this.queryData);
            // this.getuserlist(this.queryData.currentPage,this.queryData.pageSize);
            this.listByPageFun();
            //console.log(`当前页: ${val}`);
        },
        //列表
        listByPageFun() {
            listByPage({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
                query: this.queryData.query
            })
                .then(res => {
                    //console.log(res, "用户列表==成功");
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total || 0;
                        this.queryData.pages = res.data.pages || 0;
                        //console.log(this.queryData, "this.queryData");
                    }else{
                                this.$message.error(res.message);
                            }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },

        //新增用户---修改用户信息
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // alert("submit!");
                    // this.ruleForm
                    let userState = this.ruleForm.salt ? 1 : 0;
                    let param = {
                        userState: userState,
                        username: this.ruleForm.username,
                        fullname: this.ruleForm.fullname1,
                        password: this.ruleForm.password1,
                        telephone: this.ruleForm.telephone
                    };
                    if (this.ruleForm.id) {
                        param.id = this.ruleForm.id;
                        updateUser(param)
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        message: "修改成功",
                                        type: "success"
                                    });
                                    this.listByPageFun();
                                }else{
                                this.$message.error(res.message);
                            }
                            })
                            .catch(err => {
                               this.$message.error(err.message);
                            });
                    } else {
                        insertUser(param)
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        message: "新增成功",
                                        type: "success"
                                    });
                                    this.listByPageFun();
                                }else{
                                this.$message.error(res.message);
                            }
                            })
                            .catch(err => {
                                this.$message.error(err.message);
                            });
                    }
                    
                    this.$refs[formName].resetFields();
                    this.ruleForm.salt = false;
                    this.dialogVisible = false;
                } else {
                    //console.log("error submit!!");
                    return false;
                }
            });
        },

        //禁用用户
        disableUserFun(id) {
            let that = this;
            this.$confirm("确定禁用该用户么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    disableUser({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "禁用成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                           this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消禁用"
                    });
                });
        },

        //启用  enableUserFun
        enableUserFun(id) {
            let that = this;
            this.$confirm("确定启用该用户么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    enableUser({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "启用成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消启用"
                    });
                });
        },
        //删除用户
        deleteUserFun(id) {
            let that = this;
            this.$confirm("确定删除该用户么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    deleteUser({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },

        //修改用户信息
        listByIdsFun(row) {
            //console.log(row,'row');
            this.ruleForm = {
                username: row.username,
                fullname1: row.fullname,
                telephone: row.telephone,
                passwordSure: row.password,
                password1: row.password,
                salt: row.userState == 1 ? true : false,
                id: row.id
            };
            this.dialogVisible = true;
        },

        //重置密码
        resetPasswordFun(id) {
            let that = this;
            this.$confirm("确定重置该用户密码么？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    resetPassword({
                        id: Number(id)
                    })
                        .then(res => {
                            if (res.code == 200) {
                                that.$message({
                                    message: "重置密码成功",
                                    type: "success"
                                });
                                this.listByPageFun();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                        });
                })
                .catch(err => {
                    //console.log(err, "错误");
                    this.$message({
                        type: "info",
                        message: "已取消重置密码"
                    });
                });
        }
    },
    mounted() {},
    created() {
        this.listByPageFun();
    },
    computed: {
        // editor() {
        //     return this.$refs.myQuillEditor.quill;
        // }
    }
};
</script>

<style lang="less" scoped>
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;
        font-style: italic;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
.hide{
    display: none;
}
</style>
